import { useState, useEffect } from 'react'
import { DashboardLayout } from '../../components/layout'

function AgentStatusPanel() {
  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Agent Status</h3>
      </div>
      <div className="card-body">
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
          <span style={{
            width: 10,
            height: 10,
            borderRadius: '50%',
            background: 'var(--success)',
            display: 'inline-block',
            boxShadow: '0 0 6px var(--success)',
          }} />
          <strong style={{ fontSize: '1.1rem' }}>Mantis</strong>
          <span className="badge badge-success" style={{ marginLeft: 'auto' }}>Online</span>
        </div>
        <table className="table" style={{ marginBottom: 0 }}>
          <tbody>
            <tr>
              <td style={{ fontWeight: 500, color: 'var(--gray-500)', border: 'none', padding: '4px 8px' }}>Model</td>
              <td style={{ border: 'none', padding: '4px 8px' }}><code>claude-sonnet-4-6</code></td>
            </tr>
            <tr>
              <td style={{ fontWeight: 500, color: 'var(--gray-500)', border: 'none', padding: '4px 8px' }}>Last Heartbeat</td>
              <td style={{ border: 'none', padding: '4px 8px' }}>{new Date().toLocaleString()}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}

const PROJECTS = [
  { name: 'Mise iOS', status: 'Active', color: 'var(--success)' },
  { name: 'WhenWorks', status: 'Launch Ready', color: 'var(--primary-500)' },
  { name: 'Audie', status: 'Planning', color: 'var(--warning)' },
  { name: 'Mission Control', status: 'In Progress', color: 'var(--primary-400)' },
]

function ProjectsPanel() {
  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Projects</h3>
      </div>
      <div className="card-body" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
        {PROJECTS.map(p => (
          <div key={p.name} style={{
            padding: '16px',
            borderRadius: 'var(--border-radius)',
            border: '1px solid var(--gray-200)',
            background: 'var(--gray-50)',
          }}>
            <div style={{ fontWeight: 600, marginBottom: '4px' }}>{p.name}</div>
            <span style={{
              fontSize: '0.8rem',
              padding: '2px 8px',
              borderRadius: '12px',
              background: p.color,
              color: '#fff',
            }}>{p.status}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

function CronJobsPanel() {
  const [crons, setCrons] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetch('/api/openclaw/crons')
      .then(r => r.json())
      .then(data => setCrons(data))
      .catch(() => setCrons([]))
      .finally(() => setLoading(false))
  }, [])

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Cron Jobs</h3>
      </div>
      <div className="card-body p-0">
        {loading ? (
          <div style={{ padding: '24px', textAlign: 'center', color: 'var(--gray-400)' }}>Loading...</div>
        ) : crons.length === 0 ? (
          <div style={{ padding: '24px', textAlign: 'center', color: 'var(--gray-400)' }}>No cron jobs configured</div>
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Schedule</th>
                <th>Enabled</th>
              </tr>
            </thead>
            <tbody>
              {crons.map((c, i) => (
                <tr key={i}>
                  <td>{c.name || '—'}</td>
                  <td><code>{c.schedule || '—'}</code></td>
                  <td>
                    <span className={`badge ${c.enabled !== false ? 'badge-success' : 'badge-secondary'}`}>
                      {c.enabled !== false ? 'Yes' : 'No'}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  )
}

function MemoriesPanel() {
  const [memories, setMemories] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetch('/api/openclaw/memories')
      .then(r => r.json())
      .then(data => setMemories(data))
      .catch(() => setMemories([]))
      .finally(() => setLoading(false))
  }, [])

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Memories</h3>
        <span style={{ fontSize: '0.85rem', color: 'var(--gray-400)' }}>Last 3 daily logs</span>
      </div>
      <div className="card-body">
        {loading ? (
          <div style={{ textAlign: 'center', color: 'var(--gray-400)' }}>Loading...</div>
        ) : memories.length === 0 ? (
          <div style={{ textAlign: 'center', color: 'var(--gray-400)' }}>No memory logs found</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {memories.map((m, i) => (
              <div key={i} style={{
                padding: '12px',
                borderRadius: 'var(--border-radius)',
                border: '1px solid var(--gray-200)',
                background: 'var(--gray-50)',
              }}>
                <div style={{ fontWeight: 600, fontSize: '0.85rem', marginBottom: '4px', color: 'var(--primary-600)' }}>
                  {m.date}
                </div>
                <div style={{ fontSize: '0.85rem', color: 'var(--gray-600)', whiteSpace: 'pre-wrap' }}>
                  {m.preview}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

function MissionControlPage() {
  return (
    <DashboardLayout title="Mission Control">
      <div className="grid grid-2 mb-8">
        <AgentStatusPanel />
        <ProjectsPanel />
      </div>
      <div className="grid grid-2 mb-8">
        <CronJobsPanel />
        <MemoriesPanel />
      </div>
    </DashboardLayout>
  )
}

export default MissionControlPage
